var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGetAdvice(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 38.937,
    height: 34.595,
    viewBox: "0 0 38.937 34.595",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.345,35.6a3.947,3.947,0,0,0,2.163,3.521v.539a8.047,8.047,0,0,1-6.936-2.435,10.867,10.867,0,0,1-2.8.363c-5.376,0-9.734-3.874-9.734-8.653s4.358-8.653,9.734-8.653,9.734,3.874,9.734,8.653a7.982,7.982,0,0,1-1.8,5.018A3.926,3.926,0,0,0,39.345,35.6ZM19.877,5.143c9.412,0,17.069,6.1,17.3,13.707a13.263,13.263,0,0,0-5.4-1.133,12.88,12.88,0,0,0-8.59,3.183,10.678,10.678,0,0,0-3.713,8.038,10.372,10.372,0,0,0,.937,4.319c-.177,0-.354.007-.532.007a21.372,21.372,0,0,1-2.7-.17c-3.717,3.717-8.154,4.384-12.444,4.482v-.91c2.316-1.135,4.326-3.2,4.326-5.565a6.528,6.528,0,0,0-.073-.97C5.074,27.554,2.571,23.616,2.571,19.2,2.571,11.438,10.319,5.143,19.877,5.143Z",
    transform: "translate(-2.571 -5.143)",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGetAdvice);
export default __webpack_public_path__ + "static/media/get_advice.41296386dc1bbb0eddd3d23c3f2320cb.svg";
export { ForwardRef as ReactComponent };